/* src/app/modules_v2/booking/locations/components/sections/location-payments-section/location-payments-section.component.css */
.payments-section {
}
.payments-card {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 1.25rem;
  margin-bottom: 1rem;
  background: #fff;
}
.payments-card--pending {
  border-color: #f0c674;
  background: #fff8e6;
}
.payments-card--active {
  border-color: #c8e6c9;
  background: #f1f8f3;
}
.payments-card__head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}
.payments-card__head mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
}
.payments-card__icon--ok {
  color: #2e7d32;
}
.payments-card__icon--pending {
  color: #c98a00;
}
.payments-card__icon--active {
  color: #2e7d32;
}
.payments-card__bullets {
  list-style: none;
  padding: 0;
  margin: 0 0 1rem;
}
.payments-card__bullets li {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
}
.payments-card__bullets mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.payments-card__actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.info-box {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border: 1px solid #d8e7fb;
  background: #f1f7ff;
  color: #1e4a7a;
  border-radius: 8px;
}
.info-box mat-icon {
  color: #1e6cb8;
}
code {
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.85em;
}
.policy-toggle {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}
/*# sourceMappingURL=location-payments-section.component.css.map */
